import { HoneyloveWindow } from '../models/HoneyloveWindow';
import { Shopify } from '../models/Shopify.model';
import { ShopifyCheckout } from '../models/ShopifyCheckout.model';
import { ShopifyLineItem } from '../models/ShopifyLineItem.model';
import {
  trackProductClicked,
  trackProductDetailViewed,
  trackSizingToolStarted,
  trackSizingToolCompleted,
  trackSizingToolStyleSelected,
  trackNavigationLinkClicked,
  trackUserDetected,
  trackCheckoutStepEncountered,
  trackOutOfStockRedirectViewed,
  trackOutOfStockRedirectClicked,
  trackReferralPromoViewed,
  trackReferralPromoClicked,
  trackCartPromoClicked,
  trackVideoEngaged,
  trackEmailSubscriptionStarted,
  trackEmailSubscriptionCompleted,
  trackPurchase,
  trackUserSignedIn,
  trackUserSignedOut,
  trackUserRegistered,
  trackCheckoutValidationErrorEncountered,
  trackFormInteraction,
  trackPaymentGatewayUsed,
  lineItemToProduct,
  lineItemToVariant,
  trackPurchaseRefererTest,
  trackPurchaseTimingTest,
  trackPurchaseDualTest,
} from './events';

declare const window: HoneyloveWindow;

// eslint-disable-next-line no-console
console.log('Script JS: tracking.bundle.js');

const trackRawCheckoutStepEncountered = (theShopify: Shopify, lineItems: ShopifyLineItem[], step: string, option: string) => {
  const productList = lineItems.map((lineItem: ShopifyLineItem) => ({
    product: lineItemToProduct(lineItem),
    variant: lineItemToVariant(lineItem),
  }));
  trackCheckoutStepEncountered(theShopify, productList, step, option);
};

const trackRawPurchase = (shopifyCheckout: ShopifyCheckout, lineItems: ShopifyLineItem[]) => {
  const productList = lineItems.map((lineItem) => ({
    product: lineItemToProduct(lineItem),
    variant: lineItemToVariant(lineItem),
  }));
  trackPurchase(shopifyCheckout, productList);
};

export interface HoneyloveTracking {
  trackProductClicked: Function;
  trackRawCheckoutStepEncountered: Function;
  trackRawPurchase: Function;
  trackProductDetailViewed: Function;
  trackSizingToolStarted: Function;
  trackSizingToolCompleted: Function;
  trackSizingToolStyleSelected: Function;
  trackNavigationLinkClicked: Function;
  trackUserDetected: Function;
  trackCheckoutStepEncountered: Function;
  trackOutOfStockRedirectViewed: Function;
  trackOutOfStockRedirectClicked: Function;
  trackReferralPromoViewed: Function;
  trackReferralPromoClicked: Function;
  trackCartPromoClicked: Function;
  trackVideoEngaged: Function;
  trackEmailSubscriptionStarted: Function;
  trackEmailSubscriptionCompleted: Function;
  trackPurchase: Function;
  trackUserSignedIn: Function;
  trackUserSignedOut: Function;
  trackUserRegistered: Function;
  trackCheckoutValidationErrorEncountered: Function;
  trackFormInteraction: Function;
  trackPaymentGatewayUsed: Function;
  trackPurchaseRefererTest: Function;
  trackPurchaseTimingTest: Function;
  trackPurchaseDualTest: Function;
}

window.honeyloveTracking = {
  trackProductClicked,
  trackRawCheckoutStepEncountered,
  trackRawPurchase,
  trackProductDetailViewed,
  trackSizingToolStarted,
  trackSizingToolCompleted,
  trackSizingToolStyleSelected,
  trackNavigationLinkClicked,
  trackUserDetected,
  trackCheckoutStepEncountered,
  trackOutOfStockRedirectViewed,
  trackOutOfStockRedirectClicked,
  trackReferralPromoViewed,
  trackReferralPromoClicked,
  trackCartPromoClicked,
  trackVideoEngaged,
  trackEmailSubscriptionStarted,
  trackEmailSubscriptionCompleted,
  trackPurchase,
  trackUserSignedIn,
  trackUserSignedOut,
  trackUserRegistered,
  trackCheckoutValidationErrorEncountered,
  trackFormInteraction,
  trackPaymentGatewayUsed,
  trackPurchaseRefererTest,
  trackPurchaseTimingTest,
  trackPurchaseDualTest,
};

const initTracking = () => {
  watchLinks();
};

const watchLinks = () => {
  const links = document.querySelectorAll('a[data-track-label]');
  Array.from(links).forEach((link) => {
    const label = link.getAttribute('data-track-label') || undefined;
    const location = link.getAttribute('data-track-location') || undefined;
    link.addEventListener('click', (e) => {
      trackNavigationLinkClicked(label, location);
      return false;
    });
  });
};
document.addEventListener('DOMContentLoaded', initTracking);
